// ABOUTME: Route for /site-settings/team — team member management page.

import TeamPage from "@/components/site-settings/TeamPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/site-settings/team")({
  component: TeamPage,
});
